export * from './pessoas.service'


// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/pessoas/index.ts